export default function isNumber(value: ?number): boolean {
  return Number.isFinite(value);
}
